export default __webpack_public_path__ + "static/media/8.9cb55ab2.png";